<template>
  <div
    v-bind="{ scopedSlots: $scopedSlots }"
    ref="content"
    class="orgchart-container"
    @wheel="zoom && zoomHandler($event)"
  >
    <div style="z-index: 2; position: absolute; right: 0px; top: 0px; display: flex;">
      <v-btn icon @click="reset_position">
        <v-icon large>mdi-fullscreen</v-icon>
      </v-btn>

      <SearchText @input="search"/>
    </div>
    <div
      ref="content_chart"
      class="orgchart"
      style="width: fit-content !important;"
      :style="{ cursor: cursorVal }"
    >
      <organization-chart-node 
        :datasource="datasource" 
        :search_text="text" 
        :handle-click="handleClick" 
        :expandable="expandable" 
        :active="current_active"
        @expanded="expanded"
      >
        <template v-for="slot in Object.keys($scopedSlots)" :slot="slot" slot-scope="scope">
          <slot :name="slot" v-bind="scope"/>
        </template>
      </organization-chart-node>
    </div>
  </div>
</template>


<style lang="scss">
 @import "@/sass/orgchart.scss";
</style>


<script>
 import OrganizationChartNode from './OrganizationChartNode.vue';
 import Panzoom from '@panzoom/panzoom'; /* https://github.com/timmywil/panzoom#usage */
 import SearchText from '@/components/SearchText';

 const ZOOM_FACTOR = 0.25;

 export default {
   name: 'OrganizationChart',
   
   components: {
     OrganizationChartNode,
     SearchText
   },

   props: {
     datasource: {
       type: Object,
       required: true
     },
     pan: {
       type: Boolean,
       required: false
     },
     zoom: {
       type: Boolean,
       required: false
     },
     zoomoutLimit: {
       type: Number,
       required: false,
       default: 0.5
     },
     zoominLimit: {
       type: Number,
       required: false,
       default: 7
     },
     expandable: {
       type: Boolean,
       required: false,
       default: false
     },
     active: {
       required: false,
     },
   },
   
   data: () => ({
     cursorVal: 'default',
     current_active: null,
     text: null,
   }),

   mounted() {
     this.panzoom = new Panzoom(this.$refs.content_chart, {
       maxScale: this.zoominLimit,
       minScale: this.zoomoutLimit,
       step: ZOOM_FACTOR,
     })
     this.reset_position();
   },

   beforeDestroy() {
     this.panzoom.destroy();
   },

   methods: {
     handleClick(nodeData) {
       this.$emit('node-click', nodeData);
       this.current_active = nodeData.id;
     },

     zoomHandler(e) {
       this.panzoom.zoomWithWheel(e);
       return false;
     },

     expanded(data, expand) {
       // Right now it has no more uses
       this.reset_position();
     },

     search(text) {
       this.text = text ? text.toLowerCase() : null;
     },

     reset_position() {
       this.panzoom.pan(0, 0);
       this.panzoom.zoom(1);
     },
   },

   watch: {
     active() {
       if (this.active) {
         this.current_active = this.active.id;
       }
     },

     datasource() {
       this.current_active = null;
       this.reset_position();
     },
   },
 };
</script>
